/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import { createSelector } from "reselect";

// --- for All Owns ---
// ----------------------------------------------------------------------

// Function to retrieve piece of state
const dataOwns = (state: any) => state.state_own.owns;

// Function that has our select logic. Input: piece of state, Output: calcauted result
// This selector is for caching all owns, so simply return all owns is the logic.
const getAllOwns = (owns: any) => {
  return owns;
};

// Selector consumed by components consuming
export const selectorOwns = createSelector(
  [dataOwns], // pick off piece of state
  getAllOwns, // function with logic
);

// Selector consumed by action creator to check if owns are loaded
export const allOwnsLoaded = createSelector(
  [dataOwns], // pick off piece of state
  (owns) => owns !== undefined, // function with logic, return true/false only here
);

// --- for Current (single) Own ---
// ----------------------------------------------------------------------

// Function to retrieve piece of state
const dataOwnId = (state: any, props: any) => {
  return { uid: props.uid, cid: props.cid };
};
const dataCurrentOwn = (state: any) => state.state_own.currentOwn;

// Selector consumed by components consuming
export const selectorCurrentOwn = createSelector(
  [dataCurrentOwn],
  (currentOwn) => currentOwn,
);

// Selector consumed by action creator to check if the own is loaded
export const currentOwnLoaded = createSelector(
  [dataOwnId, dataCurrentOwn],
  (ownRequested_id, currentOwn) =>
    currentOwn && currentOwn.course === ownRequested_id.cid,
);
